import React from 'react';
import { PORTMONE_MERCHANT_ID } from '../../../shared/env.config';
import { useApplePaySession } from '../hooks/useApplePaySession';
import { EMERCHANT_PAY_GATEWAY } from '../payment.constants';
import { ApplePayButton } from './ApplePayButton/ApplePayButton';
import { GooglePayBtn } from './GooglePayBtn';

interface EMerchantPayProps {
    orderId: string;
    orderAmount: number;
    currencyCode: string;
    onPaymentCompleted: (provider: string, response: Record<string, unknown> | google.payments.api.PaymentData) => void;
    onError: (err?: unknown) => void;
    innerClassName?: string;
    isSandbox?: boolean;
}

const EMerchantPay = (props: EMerchantPayProps) => {
    const {
        orderAmount,
        currencyCode,
        innerClassName = '',
        onPaymentCompleted,
        onError,
        isSandbox = false,
    } = props;

    const isApplePaySupported =
        typeof window !== 'undefined' &&
        Boolean(window.ApplePaySession);

    const handlePaymentCompleted = (provider: string) => (data: Record<string, unknown> | google.payments.api.PaymentData) => {
        onPaymentCompleted(provider, data);
    };

    const { requestApplePay } = useApplePaySession({
        currencyCode,
        countryCode: 'DE',
        onPaymentAuthorized: (applePayment, completePayment) => {
            completePayment();
            handlePaymentCompleted('applepay')(applePayment.payment as Record<string, unknown>);
        },
    });

    return (
        <div id="embeddedButtons">
            {isApplePaySupported ? (
                <ApplePayButton onClick={requestApplePay} text="" />
            ) : (
                <GooglePayBtn
                    orderAmount={orderAmount}
                    currencyCode={currencyCode}
                    gateway={EMERCHANT_PAY_GATEWAY}
                    merchantId={PORTMONE_MERCHANT_ID}
                    isSandbox={isSandbox}
                    onPaymentCompleted={handlePaymentCompleted('googlepay')}
                    onError={onError}
                    innerClassName={innerClassName}
                />
            )}
        </div>
    );
};

const EMerchantPayMemo = React.memo(EMerchantPay);
export { EMerchantPayMemo as EMerchantPay };
